import { gql } from '@apollo/client'

import { INVITATION_FRAGMENT } from '../fragments'

export const GET_TENANT_INVITATIONS = gql`
  query GetTenantInvitations(
    $pagination: OffsetPaginationInput
    $filters: InvitationFilter
    $order: InvitationOrder
  ) {
    tenantInvitations(
      pagination: $pagination
      filters: $filters
      order: $order
    ) {
      results {
        ...Invitation
      }
      pageInfo {
        limit
        offset
      }
      totalCount
    }
  }
  ${INVITATION_FRAGMENT}
`
